import { AdvCoreFilter, QuickFilterDto } from "generated/CoreApi_v1";

export enum AdvFilterStandardPicker { Channel, Topic, TopicHierarchical, User, CustomField, Period, Group, Unit, Training, Workplace, Sticker, Language, Tag, Switch, TextField, DateField }

export interface IAdvFilterResult extends AdvCoreFilter {
    /**
     * Filtro Rápido associado.
     */
    quickFilter: QuickFilterDto | null;

    /**
     * Esconder o comando na linha de Chips?
     */
    hideChip?: boolean;

    /**
     *  Valor utilizado para criar um Grupo de Opções Mutualmente Exclusiva (xor) dentro de um Grupo
    */
    optionalGroup?: any;
}

export interface IAdvFilterBaseCommand {
    /** Chave utilizada para identificar o comando */
    command: any;

    /** Valor utilizado para agrupar o comando */
    group: number;

    /** Valor utilizado para criar um Grupo de Opções Mutualmente Exclusiva (xor) dentro de um Grupo */
    optionGroup?: any;

    /** Nome de Exibição do comando */
    displayName: string;

    /** Texto exibido do CHIP antes do valor do comando */
    displayPreText?: string;

    /** Comando permite mútipla seleção? */
    canRepeat?: boolean;

    /** PlaceHolder para inputs do tipo texto */
    placeholder?: string;
}

export interface IAdvFilterCommand extends IAdvFilterBaseCommand {
    /** Tipo de Picker utilizado para selecionar valores */
    picker?: AdvFilterStandardPicker;

    /** Picker Customizado */
    CustomPicker?: React.FC<IAdvFilterPickerProps>;

    /** Opções (valores) utilizadas pelo picker para construir a seleção de valores do Comando */
    options?: IAdvFilterBaseCommand[];

    /** Atribui um Valor Fixo ao comando */
    fixedValue?: any;

    /** Deve marcar esta opção com um Check? */
    canCheck?: boolean;

    /** Não exibir este filtro no formato de Chip? */
    hideChip?: boolean;

    /** Associa este comando a um tipo de 'QuickFilter'. Veja QuickFilters em Foundation. */
    quickFilterType?: any;

    /** Paramametros adicionais que devem ser enviados ao picker - exemplos de filtros */
    pickerParams?: any;
}

export interface IAdvFilterDropdown {
    textOrIcon: React.ReactNode;
    disabled?: boolean;
    title: string;
    filterCommands: IAdvFilterCommand[];
}

export interface IAdvFilterPickerProps {
    filter: IAdvFilterCommand;
    onApply: (result: IAdvFilterResult | IAdvFilterResult[], filter: IAdvFilterCommand) => void;
    onError: (e: any) => void;
    onCancel: () => void;
}

export interface IAdvFilterMenuItem<T> {
    text: string;
    value: T;
    group: number;
    disabled?: boolean;
    checked?: boolean;
}

export interface IAdvFilterParams<TOrder> {
    searchText: string;
    advFilters: IAdvFilterResult[];
    order: TOrder;
}
